// Supprime les espaces en début / fin des codes (et noms des races) des référentiels
// animaux, dont les codes servent de valeurs de filtre à l'API externe
// (ex. "Maine_coon " rendait /animals?races=Maine_coon inutilisable).
// Une valeur nettoyée qui entrerait en conflit avec un code / nom déjà existant
// (même groupe, même espèce pour les races) n'est pas modifiée et est signalée.

const REFERENTIALS = [
    {entity: 'Race', paths: ['code', 'name'], uniqueWith: ['animalType']},
    {entity: 'AnimalType', paths: ['code'], uniqueWith: []},
    {entity: 'Compatibility', paths: ['code'], uniqueWith: []}
]

const UNTRIMMED = /^\s|\s$/

async function adaptReferential({entity, paths, uniqueWith}) {
    const collection = global.app.C[entity].collection
    const documents = await collection.find({$or: paths.map(path => ({[path]: UNTRIMMED}))}).toArray()

    let modified = 0
    const conflicts = []
    for (const document of documents) {
        const update = {}
        for (const path of paths) {
            if (typeof document[path] !== 'string' || !UNTRIMMED.test(document[path])) continue
            const trimmed = document[path].trim()
            const duplicate = await collection.findOne({
                _id: {$ne: document._id},
                group: document.group,
                [path]: trimmed,
                ...Object.fromEntries(uniqueWith.map(field => [field, document[field]]))
            })
            if (duplicate) conflicts.push(`${entity} "${document[path]}" (${path} "${trimmed}" déjà utilisé)`)
            else update[path] = trimmed
        }
        if (Object.keys(update).length) {
            await collection.updateOne({_id: document._id}, {$set: update})
            modified++
        }
    }
    return {modified, conflicts}
}

async function applyJob() {
    const messages = []
    const conflicts = []
    for (const referential of REFERENTIALS) {
        const result = await adaptReferential(referential)
        messages.push(`${referential.entity} : ${result.modified} corrigé(s)`)
        conflicts.push(...result.conflicts)
    }
    const conflictMessage = conflicts.length ? ` — non corrigé(s) car en doublon : ${conflicts.join(', ')}` : ''
    return {message: messages.join(', ') + conflictMessage}
}

export const job = {
    name: "adaptAnimalReferenceCodes",
    title: "Supprimer les espaces en début / fin des codes des races, espèces et compatibilités",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
